import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./scss/index.scss";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import { AuthProvider } from "./context/AuthContext";
import { DataProvider } from "./context/DataContext";
import { UserProvider } from "./context/UserContext";

// ------------------------
// Register Service Worker
// ------------------------
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    registerSW({
      immediate: true,
      onNeedRefresh() {
        console.log("New content available, reload app.");
      },
      onOfflineReady() {
        console.log("App ready for offline use.");
      },
    });
  });
}

// ------------------------
// Render React App
// ------------------------
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Missing application root element");
}

createRoot(rootElement).render(
  <StrictMode>
    <Router>
      <AuthProvider>
        <DataProvider>
          <UserProvider>
            <App />
          </UserProvider>
        </DataProvider>
      </AuthProvider>
    </Router>
  </StrictMode>
);
